/**
 * 全局环境配置
 * 生产环境
 */
// ============================================================================
// 2026-10-14 改为**同源相对路径**（上线前实测发现，测试环境发现不了的问题）
// ----------------------------------------------------------------------------
// 背景：
//   原来 apiUrl 写的是完整域名 https://dingdang.bugu.fudijk.com/dingdang，
//   而 H5 站点本身在 https://dingdang-h5.bugu.fudijk.com ⇒ **跨域**。
//   实测生产接口**完全不返回 Access-Control-Allow-Origin 头**：
//       POST https://dingdang.bugu.fudijk.com/dingdang/user/check_user_status
//         -> HTTP 200 + 正常 JSON，但 CORS 头数量 = 0
//   浏览器会直接拦掉响应 ⇒ H5 所有接口调用失效（页面能开、功能全废）。
//   测试环境没暴露的原因：它的接口域名 dingdang-api-t.lotusdale.com 回了
//   `Access-Control-Allow-Origin: *`，生产没有。
//
// 改法：用相对的 /dingdang 前缀，由 nginx 同源反代，从根上消除跨域。链路（已实测通）：
//   浏览器 https://dingdang-h5.bugu.fudijk.com/dingdang/xxx
//     → APP-1 openresty（整站反代 location ^~ / → 10.2.178.4:80）
//     → APP-3 nginx（dingdang-h5.conf 的 location /dingdang/ 反代）
//     → http://10.2.178.3:51045/dingdang/xxx（叮当 Java 服务）
//   实测：POST /dingdang/user/check_user_status -> HTTP 200 ✓
//
// ⚠️ 与 agui-h5 的有意差异：agui-h5 测试与生产都用相对 /mall；
//    本项目测试环境仍走完整域名 + CORS（那条路本身是通的），只有生产改同源。
//    若将来把测试也统一成同源，需同步改 env.test.js。
//
// ⚠️ 开发环境（env.js / env.dev.js）保持 /ddy-api 相对前缀，由 vue.config.js 的
//    devServer.proxy 转发；deploy/build.sh 会检查产物里**不含** /ddy-api，
//    防止 dev 产物被误发到线上。
// ============================================================================
//资源配置
let signKeyAndroid = 'qn8h5jcj68xcm8zbwi6xshf3m8fock4b',
    signKeyIOS = 'w1q7i2wvld32msm8g0zsslay2hpr8wm0',
    signKeyWap = 't4eq4t1lp2k2p6jvcvi30zjp5wj9w7nw',
    signKeyWeiXin = '51qbi7wvldbbmsm8g0zsslayskdr8wjk',
    signKeyJavaApi = '0wozzzzzz4ddqe3fpo',
    apiUrl = '/dingdang',
    javaApiUrl = '/dingdang',
    domain = 'https://dingdang-h5.bugu.fudijk.com';

//输出
export default {
  signKeyAndroid,
  signKeyIOS,
  signKeyWap,
  signKeyWeiXin,
  signKeyJavaApi,
  apiUrl,
  javaApiUrl,
  domain,
}
